import { EvacZone, EvacZoneStatus, FormEvacZoneStatus } from 'shared/types';
import { Wildfire } from 'features/wildfires/wildfire.types';
import { Flooding } from 'features/flooding/flooding.types';
import { useTranslation } from 'react-i18next';
import { enqueueSnackbar } from 'notistack';

type UseHandleEvacZoneClickParams = {
  regionEvacZones: EvacZone[];
  evacZoneStatuses: FormEvacZoneStatus[];
  geoEvent?: Wildfire | Flooding;
  setValue: (name: string, value: FormEvacZoneStatus[]) => void;
};

export type UseHandleEvacZoneClickReturn = (
  uidV2: string,
  nextStatus?: EvacZoneStatus,
) => void;

export const useHandleEvacZoneClick = ({
  regionEvacZones,
  evacZoneStatuses,
  geoEvent,
  setValue,
}: UseHandleEvacZoneClickParams): UseHandleEvacZoneClickReturn => {
  const { t } = useTranslation();
  return (uidV2: string, nextStatus?: EvacZoneStatus) => {
    const evacZone = regionEvacZones.find((zone) => zone.uidV2 === uidV2);

    if (!evacZone) {
      return;
    }

    if (evacZone.isLocked) {
      enqueueSnackbar(t('geoEventEvacuations.locked'), { variant: 'error' });
      return;
    }

    const filteredCurrentZones = evacZoneStatuses.filter(
      (eZS) => eZS.evacZone.uidV2 !== uidV2,
    );

    const geoEventEvacZone = geoEvent?.evacZoneStatuses?.find(
      (eZS) => eZS.evacZone.uidV2 === uidV2,
    );

    if (nextStatus) {
      // Add
      const updatedZone: FormEvacZoneStatus = {
        evacZone: {
          ...evacZone,
          regionEvacZoneStyle: evacZone.region.evacZoneStyle,
          regionId: evacZone.region.id,
        },
        status: nextStatus,
      };
      if (geoEventEvacZone) {
        updatedZone.prevStatus = geoEventEvacZone.status;
      }

      setValue('evacZoneStatuses', [...filteredCurrentZones, updatedZone]);
      return;
    }
    // Remove
    setValue('evacZoneStatuses', filteredCurrentZones);
  };
};
